import { useRemoteData } from "@sinch/mfe-helper-react";
import { z } from "zod";
import { BILLING_CYCLE_DAY_URL } from "../api/requests/urls";

const billingCycleDayZod = z.object({
  accountId: z.string(),
  billCycleDay: z.number(),
});

export const useBillCycleDay = (isAnniversaryBilling: boolean): number => {
  const billingCycleRemote = useRemoteData(BILLING_CYCLE_DAY_URL, {
    enabled: isAnniversaryBilling,
    useToken: true,
    parse: (response) => {
      const parsed = billingCycleDayZod.safeParse(response);
      if (!parsed.success) {
        const errorMessage = "fetchAccountList_failedToParse:";
        console.error(errorMessage, parsed.error);
        throw new Error(errorMessage + parsed.error);
      }
      return parsed.data.billCycleDay;
    },
  });
  const billingCycle = billingCycleRemote.mapResult({
    onData: (data) => (data ? data : 1),
    onError: () => 1,
    onLoading: () => 1,
  });
  return billingCycle;
};
